









import { defineComponent } from "@vue/composition-api";
import { useStaticPages } from "@/hooks/useStaticPages";
import CompanyInfo from "@/components/CompanyInfo.vue";

export default defineComponent({
  name: "LandingCreatorsFooter",
  components: { CompanyInfo },
  setup() {
    const { pages, getPages } = useStaticPages();
    getPages();
    return {
      pages,
    };
  },
});
